import { forwardRef } from 'react';
import cn from 'classnames';

import styles from './rich-text.module.scss';

export interface RichTextProps {
  readonly html: string;
}

const RichText = forwardRef(
  (
    {
      className,
      html,
      ...props
    }: Omit<
      React.HTMLAttributes<HTMLDivElement>,
      'dangerouslySetInnerHTML' | 'children'
    > &
      RichTextProps,
    ref: React.ForwardedRef<HTMLDivElement>,
  ) => {
    return (
      <div
        className={cn(styles.container, className)}
        {...props}
        ref={ref}
        dangerouslySetInnerHTML={{ __html: html }}
      />
    );
  },
);

RichText.displayName = 'RichText';

export default RichText;
